import React, { Component } from "react";
import { Link } from "react-router-dom";

// Images
import bannerImg from "../../images/banner/banner1.jpg";

// Layout
import Header1 from "../layout/header/header1";

import { withTranslation } from "react-i18next";

class BecomeOurStudents extends Component {
	constructor(props) {
		super(props);
		this.state = {
			name: "",
			email: "",
			contact_number: "",
			gender: "",
			age: "",
			school: "",
			content: "",
		};
		this.itemRefs = [];
	}
	componentDidMount() {

	}

	handleChange = (event) => {
		const { name, value } = event.target;
		this.setState({ [name]: value });
	};

	render() {
		const { t } = this.props;
		const { i18n } = this.props;
		const currentLang = i18n.language;
		const learningImagePath = currentLang === 'zh'
			? require('../../images/courses/learning-pathway-zh.jpg')
			: require('../../images/courses/learning-pathway-en.jpg');

		const parentFaqImagePath = currentLang === 'zh'
			? require('../../images/courses/parent-faq-zh.jpg')
			: require('../../images/courses/parent-faq-en.jpg');

		return (
			<>
				<Header1 />

				<div className="page-content">
					<div
						className="page-banner ovbl-dark"
						style={{ backgroundImage: "url(" + bannerImg + ")" }}
					>
						<div className="container">
							<div className="page-banner-entry">
								<h1 className="text-white">{t("Header_Become_Our_Students_California")}</h1>
							</div>
						</div>
					</div>
					<div className="breadcrumb-row">
						<div className="container">
							<ul className="list-inline">
								<li>
									<Link to="/">{t("Become_Our_Students_LinkHome")}</Link>
								</li>
								<li>{t("Become_Our_Students_Link_California")}</li>
							</ul>
						</div>
					</div>
					<div className="content-block">
						<div className="page-banner contact-page">
							<div className="container-fluid container">
								<div className="row m-lr0">
									<div className="col-lg-12 col-md-12 section-sp2 p-lr30">
										<div className="heading-bx left p-r15">
											<h2 className="title-head">{t("Contact_Registration")}</h2>
										</div>
										<p className='mx-4'>
											{t("Enrollment_Message")}
										</p>

										<div className={`card-header-step`}>
											<h4 className="mb-0">
												{t("First_Poster_Title")}
											</h4>
										</div>
										<div className="card-body">
											<div className="learning-pathway">
												<img alt={t("First_Poster_Text")} src={learningImagePath} />
											</div>
											<div style={{ marginTop: "10px", textAlign: "center", fontStyle: "italic", color: "#555" }}>
												{t("First_Poster_Text")}
											</div>
										</div>
										<div className={`card-header-step`}>
											<h4 className="mb-0">
												{t("Second_Poster_Title")}
											</h4>
										</div>
										<div className="card-body">
											<div className="parent-faq">
												<img alt={t("Second_Poster_Text")} src={parentFaqImagePath} />
											</div>
											<div style={{ marginTop: "10px", textAlign: "center", fontStyle: "italic", color: "#555" }}>
												{t("Second_Poster_Text")}
											</div>
										</div>
										<div className="text-center mt-4 mb-4">
											<a
												href="https://forms.gle/XXzpdLto7jXATNAp9"
												target="_blank"
												className="btn"
												rel="noopener noreferrer"
												style={{
													minWidth: "400px",
													padding: "20px 40px",
													fontSize: "24px",
												}}
											>
												{t("Registration_Button_Title")}
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default withTranslation()(BecomeOurStudents);
